import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, InfinityIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { HeroSequence } from './HeroSequence';
import { ArtworkPatch, GuaranteeBadge, GuaranteeStrip, ShopHotspot } from './BannerOverlays';
import { PrescriptionBadge, PrescriptionStrip } from './PrescriptionBadge';
import { HeroOfferSelector } from './HeroOfferSelector';
import { heroChips, media, WARRANTY_LINE } from '../data/product';
export function Hero() {
  return <section id="top" className="border-b border-white/10 bg-ink-950" data-id="element-560" data-mp="xbfht2vcv11y">
      <div className="relative" data-id="element-561" data-mp="sarvgui2n8e2">
        <img src={media.heroBanner} alt="GritVue X1 illuminated work glasses shown with its clear, amber and smoke lenses beside a mechanic wearing them" className="block h-auto w-full" data-id="element-562" data-mp="s9zwrat6gujk" />

        {/* Blanks the dead nav words baked into the banner so only the header nav reads as navigation */}
        <ArtworkPatch box={{
        left: '27.2%',
        top: '0%',
        width: '26.8%',
        height: '9.9%'
      }} data-id="element-563" data-mp="384s62qvt8p44" />

        <GuaranteeBadge box={{
        left: '16.9%',
        top: '56.4%',
        width: '16.6%',
        height: '10%'
      }} data-id="element-564" data-mp="3j6fwnlhhz5bq" />
        <ShopHotspot box={{
        left: '3.3%',
        top: '57.4%',
        width: '13.9%',
        height: '8.2%'
      }} data-id="element-565" data-mp="3o5j4tesrxrnx" />
      </div>

      <GuaranteeStrip data-id="element-566" data-mp="39cfk4yjvyxsz" />
      <PrescriptionStrip data-id="element-567" data-mp="3e9607lvoxtee" />

      <HeroOfferSelector data-id="element-568" data-mp="3e8mqutk3wdbz" />

      <div className="mx-auto grid max-w-[1400px] gap-10 px-4 py-10 sm:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-14 lg:px-8 lg:py-16" data-id="element-569" data-mp="3e7uzxw1gf3s1">
        <div data-id="element-570" data-mp="3599i633t3ssb">
          <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-grit-500" data-id="element-571" data-mp="358zoa4fn51hc">
            GritVue X1™ · America&apos;s work gear just evolved
          </p>
          <h1 className="grit-headline mt-4 text-[clamp(2.75rem,10vw,5.75rem)] font-extrabold uppercase text-offwhite" data-id="element-572" data-mp="2viy3blil3z6n">
            Build your X1.
            <br data-id="element-573" data-mp="2hkgipwnz72sy" />
            <span className="text-grit-500" data-id="element-574" data-mp="2hjyot6osd0o7">Starting at $29.95.</span>
          </h1>

          <p className="mt-5 max-w-xl border-l-4 border-grit-500 pl-4 font-display text-2xl font-bold uppercase leading-tight text-offwhite sm:text-3xl" data-id="element-575" data-mp="2ljh0rcymq1ew">
            Choose your lens. Add only what you need. Build it your way.
          </p>

          <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-steel-300 sm:text-base" data-id="element-576" data-mp="ic85x8ls7uuo">
            GRITVUE X1™ puts hands-free light and all-day comfort right where you need it. Start with one lens, add
            the full lens system, a hard case, RX capability or protection, and make it yours.
          </p>

          <div className="mt-8" data-id="element-577" data-mp="161az9dps3c50">
            <p className="mb-4 flex flex-wrap items-center gap-x-3 gap-y-2" data-id="element-578" data-mp="16342sk53hg8s">
              <span className="bg-grit-500 px-2.5 py-1 font-display text-xl font-extrabold uppercase leading-none text-ink-950" data-id="element-579" data-mp="111y8wizp7mxo">
                Free U.S. shipping
              </span>
              <span className="text-[13px] font-semibold uppercase tracking-wide text-steel-400" data-id="element-580" data-mp="3ltgndrclksov">on every order</span>
            </p>
            <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap" data-id="element-581" data-mp="3hqk747aj58o3">
              <CtaButton href="#build-your-x1" className="w-full sm:w-auto" data-id="element-582" data-mp="1xa431cdmkgik">
                Build your X1 — from $29.95
              </CtaButton>
              <CtaButton href="#pack-single" offer="single" variant="ghost" className="w-full sm:w-auto" data-id="element-583" data-mp="218tols8th4da">
                Shop Complete Systems
              </CtaButton>
            </div>
            <p className="mt-3 text-[14px] text-steel-400" data-id="element-584" data-mp="2b20qv489g495">
              Ready-made: the X1 Complete System is $49.95, with all 3 lenses and the hard case.
            </p>

            <Link to="/legal/guarantee" className="mt-5 block border-2 gold-edge bg-[#1a1408] transition-colors duration-150 ease-grit hover:bg-[#241b0b] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#f2c94c]" data-id="element-585" data-mp="2kxuebinipi5p">
              <p className="gold-plate px-4 py-2 text-[11px] font-extrabold uppercase tracking-[0.24em] text-ink-950" data-id="element-586" data-mp="umprg5n05t0l">
                Lifetime replacement on multi-packs
              </p>
              <div className="flex items-start gap-4 p-4 sm:p-5" data-id="element-587" data-mp="4bdwfeqaa7o3">
                <InfinityIcon className="mt-0.5 h-9 w-9 shrink-0 text-[#f2c94c]" aria-hidden="true" data-id="element-588" data-mp="49jca2mu6jl2" />
                <p data-id="element-589" data-mp="3vhfei78o21j8">
                  <span className="grit-headline block text-3xl font-extrabold uppercase gold-text sm:text-4xl" data-id="element-590" data-mp="3vk1hdtkm3sv4">
                    Lifetime Replacement Warranty
                  </span>
                  <span className="mt-1.5 block text-[15px] font-semibold text-steel-200" data-id="element-591" data-mp="98e23oj818eo">
                    Break it. We replace it. {WARRANTY_LINE} Terms apply.
                  </span>
                </p>
              </div>
            </Link>

            <PrescriptionBadge className="mt-4" data-id="element-592" data-mp="3rgbwbe35bteu" />
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-x-4 gap-y-2" data-id="element-593" data-mp="3mpdg0ei5qvbl">
            <span className="flex items-center gap-1" aria-hidden="true" data-id="element-594" data-mp="3mnafh0jdpjsm">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-grit-500 text-grit-500" data-id="element-595" data-mp="2u0ppo4ijxfr6" />)}
            </span>
            <span className="text-sm font-bold uppercase tracking-wide text-offwhite" data-id="element-596" data-mp="19i5fcl09zci7">4.9/5</span>
            <span className="text-sm text-steel-400" data-id="element-597" data-mp="1e9vtz368wmff">18,412 verified reviews · 50,000+ shipped across America</span>
          </div>

          <ul className="mt-8 grid grid-cols-1 gap-x-6 gap-y-2.5 border-t border-white/10 pt-6 sm:grid-cols-2" data-id="element-598" data-mp="zlslnn4qcyng">
            {heroChips.map(chip => <li key={chip} className="flex items-center gap-2.5 text-[15px] font-medium text-steel-200" data-id="element-599" data-mp="1s9571tz5n0f6">
                <CheckIcon className="h-4 w-4 shrink-0 text-grit-500" aria-hidden="true" data-id="element-600" data-mp="1x7zq8x11aqzt" />
                {chip}
              </li>)}
          </ul>
        </div>

        <HeroSequence data-id="element-601" data-mp="1jat9t93s94dr" />
      </div>
    </section>;
}